export default __webpack_public_path__ + "static/media/ttr-dot-com-bg-mobile-min.fd7a99cb.jpg";